/*eslint-disable */
<template>
  <b-container fluid>
    <div class="iq-card p-3 row justify-content-between">
      <div>
        <h4>
          <i class="font-size-18 fa-solid fa-calendar primary-color" aria-hidden="true" style="font-size: 21px; margin-right: 3px;"></i>&nbsp;
          {{cvCardTitle}}
        </h4>
        <p class="my-2 mb-0">Counselor : <b>{{ selectedCounselorName }}</b></p>
      </div>
      <div v-if="spcmCounselorMeetingList && Array.isArray(spcmCounselorMeetingList) && spcmCounselorMeetingList.length > 0">
        <div class="bg-white shadow-sm rounded-5 p-2 cursor-pointer">
          <i :title="csvTitle" class="fa-solid fa-file-csv primary-color pointer" style="font-size: 20px;" @click="spcmAnalyticsCounselorMeeting(false, true)"></i>
        </div>
      </div>
    </div>
    <iq-card class="px-3 py-4 row">
      <b-row class="w-100">
        <!-- Counselor Name Filter -->
        <b-col class="mb-2 col-12 col-sm-6 col-lg-4">
          <select v-model="whereFilter.counsellor_id" class="form-control" @change="setCounsellor" v-if="counsellorObjList.length > 0" title="Counselor List">
            <option :value="null" disabled>Choose Counselor</option>
            <option v-for="(counsellor, index) of sortedCounsellorList" :key="(index+1)" :value="counsellor.counsellor_user_id">
              {{counsellor.user_name}}
            </option>
          </select>
        </b-col>
        <!-- Counselor Name Filter -->
        <!-- Lookback filter -->
        <b-col class="mb-2 col-12 col-md-6 col-lg-4">
          <select v-model="whereFilter.lookbackFilter" class="form-control" @change="handleFilterChange()">
            <option value="month">Month wise</option>
            <option value="week">Week wise</option>
          </select>
        </b-col>
        <!-- Lookback filter -->
        <!-- date filter -->
        <b-col class="mb-2 col-12 col-md-6 col-lg-4">
          <datetime
            type="date"
            v-model="whereFilter.selectedDate"
            input-class="gide_datetime_input"
            class="datetime-theme-primary col-12 px-0"
            :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
            :phrases="{ ok: 'Continue', cancel: 'Exit' }"
            :week-start="7"
            :max-datetime="getCurrentDate()"
            @input="handleFilterChange()">
          </datetime>
          <!-- <b-col class="w-100 p-0">
            <date-range-picker opens="left" class="w-100" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange" @update="handleFilterChange"></date-range-picker>
          </b-col> -->
        </b-col>
        <!-- date filter -->
      </b-row>
    </iq-card>
    <!-- <div v-if="spcmCounselorMeetingList && Array.isArray(spcmCounselorMeetingList) && spcmCounselorMeetingList.length > 0" class="my-2">
      <div class="bg-white shadow-sm rounded-4 p-1 w-auto">
        <i :csv-title="csvTitle" class="fa-solid fa-file-csv font-size-20 primary-color" title="Download CSV" @click="spcmAnalyticsCounselorMeeting(false, true)"></i>
      </div>
    </div> -->
    <div :style="{ minHeight: (!spcmCounselorMeetingList || spcmCounselorMeetingList?.length === 0) ? '400px' : 'auto'}" class="iq-card row p-3 d-flex align-items-center">
      <b-col md="12" v-if="spcmCounselorMeetingList && Array.isArray(spcmCounselorMeetingList) && spcmCounselorMeetingList.length > 0">
        <b-table
          hover
          responsive
          :items="spcmCounselorMeetingList"
          :fields="columns"
          :no-border-collapse="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          scrollable
        >
          <template #head()="data">
            <span v-html="data.label"></span>
          </template>
          <template v-slot:cell(id)="data">
            <span style="display: block;width: 50px">{{spcmCounselorMeetingList.indexOf(data.item)+1}}</span>
          </template>
          <template v-slot:cell(student_name)="data">
            <span style="max-width: 200px;" :title="data.item.student_name" class="d-inline-block text-truncate">{{ data.item.student_name ?? "-" }}</span><br>
            <small class="text-nowrap">Id:&nbsp;{{ data?.item?.user_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Student Id" @click="doCopy( data?.item?.user_id)"></i></small><br>
            <small class="text-nowrap">Email:&nbsp;{{ data?.item?.user_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Student Email" @click="doCopy( data?.item?.user_email)"></i></small><br>
            <small v-if="data?.item?.class_name" class="text-nowrap">Class:&nbsp;{{ displayClassName(data?.item?.class_name) }}&nbsp;&nbsp;</small><br>
            <small v-if="data?.item?.board_name" class="text-nowrap">Board:&nbsp;{{ data?.item?.board_name }}&nbsp;&nbsp;</small><br>
          </template>
        </b-table>
        <div class="d-flex align-items-center mt-3 py-3">
          <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
              <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
          </b-col>
        </div>
      </b-col>
      <b-col v-else-if="spcmCounselorMeetingList && Array.isArray(spcmCounselorMeetingList) && spcmCounselorMeetingList.length === 0">
        <h5 class="text-secondary text-center">No matching meetings found.</h5>
      </b-col>
      <b-col v-else class="text-center py-5">
        <b-spinner variant="primary" class="align-middle"></b-spinner>
        <h5 class="mt-3 text-primary">Loading Meetings...</h5>
        <p class="text-muted mb-0">Please wait while Meeting records are being loaded.</p>
      </b-col>
    </div>
  </b-container>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css"
import { socialvue } from "../../../config/pluginInit.js"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import { Datetime } from "vue-datetime"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"
import moment from "moment/moment.js"
import Utility from "../../../Utils/utility.js"

export default {
  name: "SpcmAnalyticsStudentMeetings",
  components: {
    Datetime
  },
  data () {
    return {
      cvCardTitle: "Counselor Meetings Analytics",
      spcmCounselorMeetingList: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Counselor Meetings Analytics",
      sortBy: "name",
      sortDesc: false,
      whereFilter: {
        lookbackFilter: "month",
        selectedDate: new Date().toISOString().split("T")[0],
        counsellor_id: null
        // dateRange: {
        //   startDate: moment().subtract(1, "year"),
        //   endDate: moment()
        // }
      },
      counsellorObjList: [],
      totalDataCount: 0,
      selectedCounselorName: null,
      periods: [],
      csvTitle: "Download Counselors Meeting Analytics",
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    sortedCounsellorList () {
      return [...this.counsellorObjList].sort((a, b) =>
        a.user_name.localeCompare(b.user_name)
      )
    },
    columns () {
      let dynamicPeriodColumns = []
      if (this.periods && this.periods.length > 0) {
        dynamicPeriodColumns = this.periods.map(period => {
          let label = period
          // week wise header
          if (this.whereFilter.lookbackFilter === "week") {
            const [year, week] = period.split("-")
            const startDate = moment().year(year).week(week).startOf("week").format("DD MMM")
            const endDate = moment().year(year).week(week).endOf("week").format("DD MMM")
            label = `${period}<br><span class="fw-normal text-muted">${startDate} - ${endDate}</span>`
          }

          return {
            label,
            key: period,
            class: `text-left align-text-top ${this.whereFilter.lookbackFilter === "week" ? "w-200px" : "w-150px"}`,
            sortable: true
          }
        })
      }
      return [
        {
          label: "#",
          key: "id",
          class: "text-left align-text-top",
          sortable: true
        },
        {
          label: "Student Name",
          key: "student_name",
          class: "text-left align-text-top w-300px",
          sortable: true
        },
        ...dynamicPeriodColumns
      ]
    }
  },
  async mounted () {
    socialvue.index()
    this.getCounselorFilterList()

    // Set counselor from URL parameter if available
    if (this.$route.params.counselor_id) {
      this.whereFilter.counsellor_id = this.$route.params.counselor_id
    }
    this.spcmAnalyticsCounselorMeeting()
  },
  methods: {
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.spcmAnalyticsCounselorMeeting(true)
    },
    /**
     * getCounselorFilterList
     */
    async getCounselorFilterList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data
        if (this.counsellorObjList && this.counsellorObjList.length > 0 && this.whereFilter.counsellor_id) {
          // setting counselor name
          const selectedCounselor = this.counsellorObjList.find(counselor => counselor.counsellor_user_id === this.whereFilter.counsellor_id)
          this.selectedCounselorName = selectedCounselor ? selectedCounselor.user_name : ""
        }
      }
    },
    /**
     * setCounsellor
    */
    async setCounsellor () {
      // Reset pagination when counselor changes
      this.currentBatchNo = 1

      // Update URL with selected counselor
      if (this.whereFilter.counsellor_id) {
        this.$router.push({
          name: this.$route.name,
          params: { counselor_id: this.whereFilter.counsellor_id }
        })
      }
      else {
        // Navigate without counselor_id parameter
        this.$router.push({
          name: this.$route.name,
          params: { counselor_id: undefined }
        })
      }

      this.spcmAnalyticsCounselorMeeting()
    },
    /**
     * getCurrentDate
     */
    getCurrentDate () {
      return new Date().toISOString().split("T")[0]
    },
    /**
     * handleFilterChange
     */
    async handleFilterChange () {
      this.currentBatchNo = 1
      this.spcmAnalyticsCounselorMeeting(false)
    },
    /**
     * spcmAnalyticsCounselorMeeting
     */
    async spcmAnalyticsCounselorMeeting (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.downloadCsv = downloadCsv

        let payload = {
          whereFilter: this.whereFilter
        }

        let spcmListResp = await Spcms.spcmAnalyticsCounselorMeeting(this, payload)
        if (spcmListResp.resp_status) {
          if (downloadCsv) {
            window.open(spcmListResp.resp_csv_file_url)
            return
          }

          this.periods = spcmListResp.periods || []

          spcmListResp.resp_data.data = spcmListResp.resp_data.data.map(item => ({
            ...item,
            meetings: item.meetings ? JSON.parse(item.meetings) : []
          }))

          if (!loadViaLoadMore) {
            this.spcmCounselorMeetingList = [ ...spcmListResp.resp_data.data ]
          }
          else {
            this.spcmCounselorMeetingList = [ ...this.spcmCounselorMeetingList, ...spcmListResp.resp_data.data ]
          }

          this.totalDataCount = spcmListResp.resp_data_total_count
        }
        else {
          this.toastMsg = spcmListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.spcmCounselorMeetingList = []
        }
      }
      catch (err) {
        this.toastMsg = "Failed to fetch counselor students. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.spcmCounselorMeetingList = []
        console.error("Exception occurred at spcmAnalyticsCounselorMeeting() and Exception:", err.message)
      }
    },
    /**
     * displayClassName
     */
    displayClassName (val) {
      if (val === null || val === undefined) return ""
      const normalizedVal = val.toString().toLowerCase()

      if (normalizedVal === "13") return "Bachelors"
      if (normalizedVal === "14") return "Postgraduate"
      if (normalizedVal === "15") return "PhD"

      return val
    }
  },
  watch: {
    "$route.params.counselor_id" (newCounselorId) {
      if (newCounselorId) {
        this.whereFilter.counsellor_id = newCounselorId
        // setting counselor name
        const selectedCounselor = this.sortedCounsellorList.find(counselor => counselor.counsellor_user_id === newCounselorId)
        this.selectedCounselorName = selectedCounselor ? selectedCounselor.user_name : ""

        this.currentBatchNo = 1
        this.spcmAnalyticsCounselorMeeting()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
